import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {Platform} from '@ionic/angular';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class PlatformControl {

    public static readonly XS = 'XS';
    public static readonly SM = 'XS';
    public static readonly MD = 'MD';
    public static readonly LG = 'LG';
    public static readonly XL = 'XL';

    private static readonly SM_MIN_WIDTH = 540;
    private static readonly MD_MIN_WIDTH = 720;
    private static readonly LG_MIN_WIDTH = 960;
    private static readonly XL_MIN_WIDTH = 1140;

    public constructor(private platform: Platform, @Inject(PLATFORM_ID) private platformId: Object){
    }

    isIOS(): boolean {
        if (isPlatformBrowser(this.platformId)) {
            return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        }
        return false;
    }

    isAndroid(): boolean {
        console.log('isAndroid', navigator.userAgent);
        if (isPlatformBrowser(this.platformId)) {
            return /Android/i.test(navigator.userAgent);
        }
        return false;
    }

    isPortraitOrientation(): boolean {
        return window.matchMedia("(orientation: portrait)").matches;
    }

    isFirefox(): boolean {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
    isAtLeast(size: string): boolean {
        // console.log(['platform', size, this.platform.width()]);
        const width = this.platform.width();
        switch (size) {
            case PlatformControl.XS:
                return true;
            case PlatformControl.SM:
                return width >= PlatformControl.SM_MIN_WIDTH;
            case PlatformControl.MD:
                return width >= PlatformControl.MD_MIN_WIDTH;
            case PlatformControl.LG:
                return width >= PlatformControl.LG_MIN_WIDTH;
            case PlatformControl.XL:
                return width >= PlatformControl.XL_MIN_WIDTH;
        }
        throw new Error('Wrong provided size ' + size);
    }

    isDesktopDisplay(): boolean {
        return this.isAtLeast(PlatformControl.XL);
    }

    getWidth(): number {
        return this.platform.width();
    }
}